import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LUP_ALINEA_EXTERNAL_URL } from '@loup-transload-ui-app/common-services';

@Injectable({
  providedIn: 'root',
})
export class RateRequestService {
  private readonly http = inject(HttpClient);
  private readonly externalUrl = inject(LUP_ALINEA_EXTERNAL_URL);

  /** POST call start */
  createRateRequest(requestObj: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/create-rate-request/1.0`,
      requestObj
    );
  }
}
